export const GET_SLIDERS = 'GET_SLIDERS';
export const GET_SLIDERS_SUCCESS = 'GET_SLIDERS_SUCCESS';
export const GET_SLIDERS_FAIL = 'GET_SLIDERS_FAIL';

export const ADD_SLIDER = 'ADD_SLIDER';
export const ADD_SLIDER_SUCCESS = 'ADD_SLIDER_SUCCESS';
export const ADD_SLIDER_FAIL = 'ADD_SLIDER_FAIL';

export const UPDATE_SLIDER = 'UPDATE_SLIDER';
export const UPDATE_SLIDER_SUCCESS = 'UPDATE_SLIDER_SUCCESS';
export const UPDATE_SLIDER_FAIL = 'UPDATE_SLIDER_FAIL';

export const DELETE_SLIDER = 'DELETE_SLIDER';
export const DELETE_SLIDER_SUCCESS = 'DELETE_SLIDER_SUCCESS';
export const DELETE_SLIDER_FAIL = 'DELETE_SLIDER_FAIL';

export const SET_SLIDER_FIELD_ERRORS = 'SET_SLIDER_FIELD_ERRORS';
